import axios from "axios";
import { useDeviceStore } from "../stores/device";
import { getTurnstileToken } from "../utils/turnstile";

const DEVICE_ID_HEADER = "X-Jukebox-Device-Id";
const TURNSTILE_TOKEN_HEADER = "X-Turnstile-Token";

// Create axios instance with default config
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:5000",
  timeout: import.meta.env.VITE_API_TIMEOUT || 10000,
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.request.use(
  async (config) => {
    try {
      const deviceStore = useDeviceStore();
      const deviceId = await deviceStore.getDeviceId();
      if (deviceId) {
        config.headers[DEVICE_ID_HEADER] = deviceId;
      }
    } catch (error) {
      console.warn("Failed to attach device ID header:", error?.message || error);
    }

    if (config.method?.toLowerCase() === "post" && config.url === "/api/votes") {
      try {
        const turnstileToken = await getTurnstileToken();
        if (turnstileToken) {
          config.headers[TURNSTILE_TOKEN_HEADER] = turnstileToken;
        }
      } catch (error) {
        console.warn("Failed to attach Turnstile token:", error?.message || error);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log detailed error information for debugging
    console.error("❌ API Error:", {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
      code: error.code
    });

    if (error.response?.status === 401) {
      // Handle unauthorized (shouldn't happen for public endpoints)
      console.error("Unauthorized access");
    }

    // Handle network errors (no response from server)
    if (!error.response) {
      console.error("❌ Network error - no response from server. Check if backend is running.");
    }

    return Promise.reject(error);
  }
);

export default api;
